import {
    bexHttpClient
} from '../../clients';
import {
    AddTuningExperimentRequest,
    UpdateTuningExperimentRequest,
    GetUserTuningExperimentsAPIResponse,
    AddTuningExperimentAPIResponse,
    UpdateTuningExperimentAPIResponse,
    DeleteTuningExperimentAPIResponse
} from '../bexService.types';

/**
 * Service class for performing Tuning Lab operations.
 */
class TuningLabService {

    /**
     * Fetches the user's tuning experiments.
     * @returns {Promise<Object>} The response from the server returns sub organization channels.
     */
    async getUserTuningExperiments(org_id: string, sub_org_id: string, user_id: string): Promise<GetUserTuningExperimentsAPIResponse> {
        const response = await bexHttpClient.get(`/db/tuning-experiment/get-user-tuning-experiments?org_id=${org_id}&sub_org_id=${sub_org_id}&user_id=${user_id}`);
        return response;
    }

    /**
     * add new tuning experiment
     * @param {Object} data - The new tuning experiment object includes org_id, sub_org_id, and any extra info
     * @returns {Promise<Object>} The response from the server returns new channel document from mongoDB.
     */
    async addTuningExperiment(data: AddTuningExperimentRequest): Promise<AddTuningExperimentAPIResponse> {
        const response = await bexHttpClient.post('/db/tuning-experiment/add-tuning-experiment', data);
        return response;
    }

    /**
     * update channel
     * @param {Object} data - The new channel object includes organizationId, subOrganizationId, topic, address and any extra info
     * @returns {Promise<Object>} The response from the server returns new channel document from mongoDB.
     */
    async updateTuningExperiment(data: UpdateTuningExperimentRequest): Promise<UpdateTuningExperimentAPIResponse> {
        const response = await bexHttpClient.put('/db/tuning-experiment/update-tuning-experiment', data);
        return response;
    }

    /**
     * delete an existing tuning experiment
     * @param {Object} data - Delete object includes org_id, sub_org_id, and tuningExperiment_id
     * @returns {Promise<Object>} The response from the server returns new channel document from mongoDB.
     */
    async deleteTuningExperiment(org_id: string, sub_org_id: string, tuningExperiment_id: string, user_id: string): Promise<DeleteTuningExperimentAPIResponse> {
        const response = await bexHttpClient.delete(`/db/tuning-experiment/delete-tuning-experiment?org_id=${org_id}&sub_org_id=${sub_org_id}&tuningExperiment_id=${tuningExperiment_id}&user_id=${user_id}`);
        return response;
    }

}

const tuningLabService = new TuningLabService();
export { tuningLabService };